module.exports = __webpack_public_path__ + "static/media/26.f49abcb7.mp3";